module.exports = __webpack_public_path__ + "static/media/thumbnail.d6861e05.jpg";